import styled from "styled-components";
import { BASIC_DARK_GRAY } from "../../../constants/colors";
import { ChangeEmailForm } from "../../organisms/form/ChangeEmailForm";
import { useChangeEmail } from "./hook";

export const ChangeEmail: React.FC = () => {
  const { handleChangeEmail } = useChangeEmail();

  return (
    <Container>
      <TitleWrapper>メールアドレスの変更</TitleWrapper>

      <ChangeEmailForm handleSubmit={handleChangeEmail} />
    </Container>
  );
};

const Container = styled.div`
  color: ${BASIC_DARK_GRAY};
  padding: 0 16px 57px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  text-align: left;
  font-family: "Hiragino Sans";
`;

const TitleWrapper = styled.div`
  font-size: 20px;
  padding: 43px 0 38px;
  display: flex;
  font-weight: 600;
  line-height: 1;
  justify-content: center;
  font-family: "Hiragino Sans";
`;
